export enum SearchParamsKeys {
  phrase = "phrase",
  dateFrom = "dateFrom",
  dateTo = "dateTo",
  status = "status",
  paymentId = "paymentId",
}
